import React from "react";
import {
  Grid, TextField, MenuItem, Typography,
} from "@mui/material";

/**
 * ThaiAddressSection — แทนที่ 4 fields เดิม (subdistrict, district, city, postalCode)
 * Props ทั้งหมดรับมาจาก CustomerGeneralForm
 */
export default function ThaiAddressSection({
  form,
  errors,
  makeRef,
  provinces,
  amphoes,
  tambons,
  handleProvinceChange,
  handleAmphoeChange,
  handleTambonChange,
}) {
  return (
    <>
      {/* Province */}
      <Grid item xs={3} ref={makeRef("city")}>
        <TextField
          select
          label="Province *"
          name="city"
          value={form.city}
          onChange={handleProvinceChange}
          fullWidth
          error={!!errors.city}
          helperText={errors.city}
        >
          <MenuItem value=""><em>— Select Province —</em></MenuItem>
          {provinces.map((p) => (
            <MenuItem key={p} value={p}>{p}</MenuItem>
          ))}
        </TextField>
      </Grid>

      {/* Amphoe (District) */}
      <Grid item xs={3} ref={makeRef("district")}>
        <TextField
          select
          label="District *"
          name="district"
          value={form.district}
          onChange={handleAmphoeChange}
          fullWidth
          disabled={!form.city}
          error={!!errors.district}
          helperText={errors.district || (!form.city ? "Select Province first" : "")}
        >
          <MenuItem value=""><em>— Select District —</em></MenuItem>
          {amphoes.map((a) => (
            <MenuItem key={a} value={a}>{a}</MenuItem>
          ))}
        </TextField>
      </Grid>

      {/* Tambon (Sub-District) */}
      <Grid item xs={3} ref={makeRef("subdistrict")}>
        <TextField
          select
          label="Sub-District *"
          name="subdistrict"
          value={form.subdistrict}
          onChange={handleTambonChange}
          fullWidth
          disabled={!form.district}
          error={!!errors.subdistrict}
          helperText={errors.subdistrict || (!form.district ? "Select District first" : "")}
        >
          <MenuItem value=""><em>— Select Sub-District —</em></MenuItem>
          {tambons.map((t) => (
            <MenuItem key={t} value={t}>{t}</MenuItem>
          ))}
        </TextField>
      </Grid>

      {/* Postal Code — auto-filled, read-only */}
      <Grid item xs={3} ref={makeRef("postalCode")}>
        <TextField
          label="Postal Code *"
          name="postalCode"
          value={form.postalCode}
          fullWidth
          disabled
          error={!!errors.postalCode}
          helperText={errors.postalCode || "Auto-filled when sub-district is selected"}
          inputProps={{ maxLength: 5 }}
        />
      </Grid>
    </>
  );
}
